var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar_ret"},[_c('div',{staticClass:"ret",on:{"click":_vm.back}},[(_vm.isBridge)?_c('img',{staticClass:"ret_img",attrs:{"src":require('@/img/' + _vm.getTheme + '-back.png'),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav_text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e073255","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/navBarIndex.vue
// module id = null
// module chunks = 